import React from 'react'
import ReactDOM from 'react-dom'
import GermanyMap from './components/GermanyMap'
import { Provider } from 'react-redux'
import store from './store'
$ = jQuery
// alert('Hi')
if (document.querySelector('#clinic_location_map')) {
    // const AddWorkFlowPage = require('./AddWorkFlow/AddWorkFlowPage').default

    ReactDOM.render(
        <Provider store={store}>
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    flexDirection: 'column',
                }}
            >
                <GermanyMap />
            </div>
        </Provider>,
        document.querySelector('#clinic_location_map')
    )
}
